var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "app-container demand" }, [_c('demand-form', { ref: "demand-form", attrs: { "id": _vm.id, "url-review-id": _vm.reviewId, "demand": _vm.demand, "products": _vm.products, "creation-list": _vm.creationList, "update-demand": _vm.updateDemand, "update-products": _vm.updateProducts, "empty-creation-list": _vm.emptyCreationList, "update-creation-list": _vm.updateCreationList }, on: { "update:products": function updateProducts($event) {
        _vm.products = $event;
      } } }), _vm._v(" "), _c('advertiser-info-dialog')], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };